import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import {
  getPortalToken,
  portalFetchMe,
  portalLogout,
  setPortalToken,
} from "../services/portalApi";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = getPortalToken();
    if (!token) {
      setCustomer(null);
      setLoading(false);
      return null;
    }
    try {
      const data = await portalFetchMe();
      setCustomer(data.customer || null);
      return data.customer;
    } catch {
      setPortalToken("");
      setCustomer(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback((accessToken, customerData) => {
    setPortalToken(accessToken);
    setCustomer(customerData || null);
  }, []);

  const logout = useCallback(() => {
    portalLogout();
    setCustomer(null);
  }, []);

  const value = useMemo(
    () => ({
      customer,
      loading,
      isAuthenticated: Boolean(customer && getPortalToken()),
      login,
      logout,
      refresh,
    }),
    [customer, loading, login, logout, refresh]
  );

  return (
    <PortalAuthContext.Provider value={value}>{children}</PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error("usePortalAuth must be used within PortalAuthProvider");
  return ctx;
}
